import { memo } from "react";
import {
  Banner,
  BlockStack,
  Text,
  InlineStack,
  useTranslate,
} from "@shopify/ui-extensions-react/customer-account";
import { PhotoUploadBannerProps } from "../types";

export const PhotoUploadBanner = memo(({ uploadButton }: PhotoUploadBannerProps) => {
  const translate = useTranslate();

  return (
    <Banner status="warning">
      <BlockStack spacing="tight">
        <Text emphasis="bold">{translate("photosRequired")}</Text>
        <Text>{translate("photosRequiredMessage")}</Text>
        <InlineStack spacing="base">{uploadButton}</InlineStack>
      </BlockStack>
    </Banner>
  );
});
